
import ProductsList from "../components/Products/ProductsList"


const Earphones = () => {
    return (
        <>
        <ProductsList />
        </>
    
    )
}

export default Earphones